import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic$dPromotions$dTypes from "../Restaumatic.Promotions.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Data$dOrd.ordInt)(Data$dFoldable.foldableArray);
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const decodeRawMenu = rawMenu => (
  {
    promotions: fromFoldable(Data$dFunctor.arrayMap(x => {
      const $0 = Restaumatic$dPromotions$dTypes.unscrambleDecodePromotion.unsafeDecode(x);
      return Data$dTuple.$Tuple($0.id, $0);
    })(rawMenu.promotions)),
    timeZone: rawMenu.time_zone,
    enableCoupons: rawMenu.enable_coupons,
    enableFod: rawMenu.enable_fod,
    enableMarketingConsents: rawMenu.enable_marketing_consents,
    catalogue: rawMenu.catalogue,
    imagePrefix: (() => {
      if (rawMenu.image_prefix.tag === "Nothing") { return "https://restaumatic.imgix.net"; }
      if (rawMenu.image_prefix.tag === "Just") { return rawMenu.image_prefix._1; }
      $runtime.fail();
    })()
  }
);
const unsafeDecodeMenu = /* #__PURE__ */ (() => {
  const $0 = Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "catalogue"})(Restaumatic$dMenu$dV2$dTypes$dMenuCatalogue.unscrambleDecodeMenuCatalogue)(Unscramble.decodeRecordCons({
    reflectSymbol: () => "enable_coupons"
  })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "enable_fod"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
    reflectSymbol: () => "enable_marketing_consents"
  })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "image_prefix"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
    reflectSymbol: () => "promotions"
  })({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeForeign.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "time_zone"})(Data$dTime$dLocal.udecodeTZLabel)(Unscramble.decodeRecordNil))))))).recordInfo(Type$dProxy.Proxy));
  return x => decodeRawMenu($0(x));
})();
const decodeMenuEither = f => Unscramble.catchDecodingErrorEither(v => unsafeDecodeMenu(f));
const decodeMenu = f => {
  const $0 = Unscramble.catchDecodingErrorEither(v => unsafeDecodeMenu(f));
  if ($0.tag === "Left") { return fail(Foreign.$ForeignError("ForeignError", $0._1)); }
  if ($0.tag === "Right") { return pure($0._1); }
  $runtime.fail();
};
export {decodeMenu, decodeMenuEither, decodeRawMenu, fail, fromFoldable, pure, unsafeDecodeMenu};
